import React, { Component } from 'react'

import SortableTable from '../Tables/SortableTable'

import { formatNumber } from '../../formatter'

import { POWER_TOTAL } from '../../models/PowerProject'

class ProjectStats extends Component {
  render () {
    let projectTotals = this.props.projectTotals
      ? Object.values(this.props.projectTotals).filter(p => p.count > 0)
      : []

    const totalMW = projectTotals
      .filter(p => p.key === POWER_TOTAL)[0].totalMW

    const columns = [
      {
        id: 'type',
        name: 'Power Type',
        accessor: d => d.key,
        displayAccessor: d => <span><i className={d.icon} />&nbsp;{d.shortName}</span>
      },
      {
        id: 'count',
        name: 'Projects',
        accessor: d => d.count,
        cellClass: 'text-right',
        headerClass: 'text-right'
      },
      {
        id: 'totalMW',
        name: 'Total MW',
        accessor: d => d.totalMW,
        displayAccessor: d => formatNumber(d.totalMW),
        cellClass: 'text-right',
        headerClass: 'text-right'
      },
      {
        id: 'propOfTotal',
        name: '% of Total MW',
        accessor: d => d.totalMW / totalMW,
        displayAccessor: d => `${formatNumber(100 * d.totalMW / totalMW)}%`,
        cellClass: 'text-right',
        headerClass: 'text-right'
      }
    ]

    const rowFilter = (r) => true

    return (
      <div className='ProjectStats'>
        <SortableTable
          columns={columns}
          baseSortColumnId={'type'}
          rows={projectTotals}
          rowFilter={rowFilter}
        />
      </div>
    )
  }
}

export default ProjectStats



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectStats.js